const electron = window.process ? window.require('electron') : null;
const ipcRenderer = electron ? electron.ipcRenderer : null;

module.exports = function(module = '') {
  const debug = require('debug')(module);
  if ('DEBUG' == localStorage.getItem('LOG_LEVEL') || 'FINE' == localStorage.getItem('LOG_LEVEL')) {
    debug.enabled = true;
  }
  const debugWrapper = function(...info) {
    if (debug.enabled && ipcRenderer) {
      let infoStringify;
      try {
        infoStringify = JSON.stringify(info);
      } catch (error) {
        infoStringify = JSON.stringify(filterInfo(info));
      }
      ipcRenderer.send('debugInWindow', { module, infoStringify });
    }
    debug(...info);
  };
  debugWrapper.enabled = debug.enabled;
  return debugWrapper;
};

const filterInfo = (info) => {
  return info.filter((element) => {
    return typeof element !== 'object';
  });
};
